import React, { Component } from 'react';
import { buildAuthLoginUrl } from '../../authConfig';
import { PREFIX_URL } from '../../constants';

class AuthGate extends Component {
  constructor(props) {
    super(props);

    this.state = this.getAuthErrorState();
  }

  componentDidMount() {
    this.clearAuthErrorFromUrl();
  }

  getAuthErrorState = () => {
    const params = new URLSearchParams(window.location.search || '');
    const authError = params.get('auth_error');

    if (!authError) {
      return {
        authError: null,
        authErrorMessage: null,
      };
    }

    const rawMessage = params.get('message') || '';
    const authErrorMessage = this.decodeAuthErrorMessage(rawMessage) || this.getDefaultAuthErrorMessage(authError);

    return {
      authError,
      authErrorMessage,
    };
  };

  getDefaultAuthErrorMessage = (authError) => {
    if (authError === 'token_exchange_failed') {
      return 'Azure sign-in failed while exchanging the authorization code. Please try again. If it keeps happening, contact your Azure admin.';
    }

    return 'Sign-in failed. Please try again.';
  };

  decodeAuthErrorMessage = (message) => {
    if (!message) {
      return null;
    }

    let decoded = message;

    for (let i = 0; i < 2; i += 1) {
      try {
        const nextDecoded = decodeURIComponent(decoded);
        if (nextDecoded === decoded) {
          break;
        }
        decoded = nextDecoded;
      } catch (error) {
        break;
      }
    }

    return decoded;
  };

  clearAuthErrorFromUrl = () => {
    const params = new URLSearchParams(window.location.search || '');

    if (!params.has('auth_error')) {
      return;
    }

    const nextUrl = `${window.location.pathname}${window.location.hash || ''}`;
    window.history.replaceState({}, document.title, nextUrl);
  };

  handleLogin = () => {
    window.location.href = buildAuthLoginUrl(`${window.location.origin}${PREFIX_URL}`);
  };

  render() {
    const { isAuthenticated, children } = this.props;

    if (!isAuthenticated) {
      const { authError, authErrorMessage } = this.state;

      return (
        <div className="auth-gate">
          <div className="auth-gate-container">
            <h2>Process Maturity Matrix</h2>
            <div className="auth-gate-separator" />
            <p>Sign in with your Azure AD account to continue</p>
            {authError && (
              <div className="auth-gate-error" role="alert" aria-live="assertive">
                <div className="auth-gate-error-title">Sign-in failed</div>
                <div className="auth-gate-error-message">{authErrorMessage}</div>
              </div>
            )}
            <button className="auth-login-btn" onClick={this.handleLogin}>
              Sign in with Azure AD
            </button>
          </div>
        </div>
      );
    }

    return children;
  }
}

export default AuthGate;
